import PayloadRegister from './PayloadRegister';

const fetchAccessToken = () => {
  return new Promise((resolve, reject) => {
    window.VSS.require(['VSS/Authentication/Services'], function (VSS_Auth_Service) {
      window.VSS.getAccessToken().then(function (t) {
        resolve(VSS_Auth_Service.authTokenManager.getAuthorizationHeader(t));
      });
    });
  });
};

/**
 * Fetch data from Azure API
 * @param {string} url url to API
 * @param {{
 * header: Object,
 * body: Object,
 * method: String,
 * version: String,
 * bodyString: String,
 * signal: Object}} options Optional. Header Object, Body (POST, PUT, DELETE), Method (Default GET or POST if Body is found), version (Default 6.0), bodyString (custom JSON), signal (Used for AbortController)
 */
const azureFetch = async (
  url = '',
  options = {
    method: 'GET',
  }
) => {
  if (!url) throw new Error('Empty url!');

  let token;
  if (PayloadRegister.isProduction()) {
    token = await fetchAccessToken();
    if (!token) throw new Error('Token not found!');
  }

  let header = {};
  if (PayloadRegister.isProduction()) {
    header.Authorization = `${token}`;
  }

  if (!options.version) options.version = '6.0';

  if (!url.includes('api-version') && options?.version) {
    if (url.includes('?')) url += `&api-version=${options.version}`;
    else url += `?api-version=${options.version}`;
  }

  if (options?.header) {
    header = Object.assign(header, options.header);
  }

  const request = { headers: header, method: 'GET' };

  if (options?.body || options?.bodyString) request.method = 'POST';

  if (options?.method) request.method = options.method;

  if (options?.signal) request.signal = options.signal;
  switch (request.method) {
    case 'POST':
    case 'PUT':
    case 'PATCH':
    case 'DELETE':
      if (!options?.bodyString) {
        if (!options.body) throw new Error('Body not found in options!');

        const { body } = options;
        if (typeof body !== 'object')
          throw new Error(`Expected body of type 'Object', received '${typeof body}'!`);
        else if (Object.keys(body).length === 0) throw new Error('Empty body!');
      }

      if (request.method === 'PATCH') {
        request.headers['Content-Type'] = 'application/json-patch+json';
      } else {
        request.headers['Content-Type'] = 'application/json;charset=utf-8';
      }

      if (options?.bodyString) request.body = options.bodyString;
      else {
        if (!PayloadRegister.isProduction()) {
          request.body = options.body;
        } else request.body = JSON.stringify(options.body);
      }
      break;
    case 'GET':
      break;
    default:
      throw new Error(`Unknown REST method: ${request.method}`);
  }
  const response = await PayloadRegister.checkForPayload(url, request)
    .then(async (data) => {
      if (!data.ok || data.status === 500) {
        console.error(data);
      }
      if (request?.method === 'PATCH' || !PayloadRegister.isProduction()) return data;
      const { status } = data;
      const parsedData = await data.json();
      return { status, ...parsedData };
    })
    .catch((error) => {
      if (error.name === 'AbortError') {
        console.log('cancelled!');
      } else {
        console.log(url);
        console.log(request);
        console.error(error);
      }
    });

  return response;
};

export default azureFetch;
